<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <adSelect v-model="filters.adid" :lists.sync="adLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">项目：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">跟单人：</div>
        <operSelect v-model="filters.opid" :lists.sync="operLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">下家：</div>
        <el-select class="filter__input" size="mini" v-model="filters.acid" filterable>
          <el-option :label="item.name" :value="item.acid" v-for="(item, index) in adChnLists" :key="index"></el-option>
        </el-select>
      </div>
      <!--
      <div class="filter__item">
        <div class="filter__name">展示：</div>
        <el-select class="filter__input" size="mini" v-model="filters.show">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in showList" :key="index"></el-option>
        </el-select>
      </div>
      -->
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <router-link class="blue-small-btn ml-auto" :to="{path: '/adWatchwordEdit', query: {awid: 0}}">新建</router-link>
    </div>
    <div class="filter mt-10 mb-20">
      <div class="filter__item">
        <div class="filter__name">收款：</div>
        <el-select class="filter__input" size="mini" v-model="filters.ieffect">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in ieffectList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">地址：</div>
        <el-input v-model="filters.address" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <button class="blue-small-btn mr-10" @click="getList">搜索</button>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700" :summary-method="getSummaries" show-summary>
      <el-table-column prop="awid" label="ID" width="50" align="center">
      </el-table-column>
      <el-table-column prop="title" label="项目" width="80" align="center">
      </el-table-column>
      <el-table-column label="复制" width="" align="center">
       <template slot-scope="scope">
          <router-link class="fs-18 ml-10" :to="{path: '/adWatchwordEdit', query: {copy_awid: scope.row.awid, awid: 0}}">
            <i class="el-icon-copy-document"></i>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="oper_nickname" label="跟单人" width="70" align="center">
      </el-table-column>
      <el-table-column prop="adid" label="广告" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('adid', scope.row.adid)">{{scope.row.ad_title}}({{scope.row.adid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="详情" width="" align="center">
        <template slot-scope="scope">
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <div>要求：{{scope.row.demand}}</div><br />
              <div>口令：{{scope.row.keyword}}</div><br />
              <div> 优惠券：{{scope.row.coupon_url}}</div><br />
              <div class="flex"> 地址：
                <div v-html="scope.row.address.replace(/\|/g, '<br />')"></div>
              </div>
            </div>
            <el-button size="mini">显示</el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="upload_url" label="交单链接" width="80" align="center">
        <template slot-scope="scope">
         <el-button type="primary" icon="el-icon-document-copy" size="mini" class="copy-btn" @click="copyLink"  :data-clipboard-text="scope.row.upload_url"></el-button>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="agent" label="之前下家" width="" align="center">
      </el-table-column>
      -->
      <el-table-column prop="acid" label="下家" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.chn_name}}({{scope.row.acid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="min_discount" label="底价折扣" width="" align="center">
        <template slot-scope="scope">
          <!--
          <div :class="{'fc-red': scope.row.use_discount, 'fc-gray': !scope.row.use_discount}">{{scope.row.min_discount}}</div>
          -->
          <div v-if="scope.row.use_discount" >{{scope.row.min_discount}}</div>
          <div v-else></div>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="demand" label="要求" width="150" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.demand.length < 20">
            <div slot="reference">{{scope.row.demand}}</div>
          </div>
          <el-popover placement="top-end" trigger="hover" :content="scope.row.demand" v-else>
            <div slot="reference"  @click="copyLink">{{scope.row.demand.slice(0, 20) + '...'}}</div>
          </el-popover>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="total" label="总单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="agency_fees" label="拍收费" width="" align="center">
      </el-table-column>
      <el-table-column prop="order_amount" label="出单金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="remain" label="剩余单数" width="" align="center">
      </el-table-column>
      <!--
      <el-table-column prop="priority" label="优先级" width="" align="center">
        <template slot-scope="scope">
          <el-select v-model="scope.row.priority" placeholder="请选择" size="mini" @change="adWatchwordEdit(scope.$index, 'priority')">
            <el-option
              v-for="item in priorityLists"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="show" label="展示" width="100" align="center">
        <template slot-scope="scope">
          <div class="flex jcc aic">
            <div v-if="scope.row.show == 0" class="blue-small-btn" @click="adWatchwordEdit(scope.$index, 'show')">内部</div>
            <div v-if="scope.row.show == 1" class="red-small-btn" @click="adWatchwordEdit(scope.$index, 'show')"> 全部</div>
          </div>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="status" label="状态" width="100" align="center">
        <template slot-scope="scope">
          <div class="flex jcc aic">
            <div v-if="scope.row.status == 1" class="blue-small-btn" @click="adWatchwordEdit(scope.$index, 'status')">运行</div>
            <div v-if="scope.row.status == 0" class="red-small-btn" @click="adWatchwordEdit(scope.$index, 'status')">停止</div>
          </div>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="keyword" label="口令" width="150" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.keyword.slice(0, 30) + '...'}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="地址" width="150" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.address.length < 20">{{scope.row.address}}</div>
          <div v-else>{{scope.row.address.slice(0, 20) + '...'}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="goods" label="商品" width="150" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.goods.length < 20">{{scope.row.goods}}</div>
          <div v-else>{{scope.row.goods.slice(0, 20) + '...'}}</div>
          <div v-if="scope.row.goods.length < 15">
            <div slot="reference">{{scope.row.goods}}</div>
          </div>
          <el-popover placement="top-end" trigger="hover" :content="scope.row.goods" v-else>
            <div slot="reference"  @click="copyLink">{{scope.row.goods.slice(0, 15) + '...'}}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="订单金额" width="" align="center">
      </el-table-column>
      -->
      <el-table-column prop="price" label="单价" width="" align="center">
      </el-table-column>
      <el-table-column prop="income" label="应收单价" width="" align="center">
      </el-table-column>
      <el-table-column prop="all_income" label="应收款" width="" align="center">
      </el-table-column>
      <el-table-column prop="chn_amount" label="已收" width="" align="center">
      </el-table-column>
      <el-table-column prop="unpaid" label="未收" width="" align="center">
       <template slot-scope="scope">
          <div v-if="scope.row.ieffect == 0" class="fc-red pointer">
            {{scope.row.unpaid}}
          </div>
          <div v-else> {{scope.row.unpaid}} </div>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="ieffect" label="收款" width="100" align="center">
        <template slot-scope="scope">
          <div class="flex jcc aic">
            <div v-if="scope.row.ieffect == 0" class="red-small-btn"  @click="adWatchwordEdit(scope.$index, 'ieffect')">未收款</div>
            <div v-if="scope.row.ieffect == 1" class="fc-blue">已收款</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="account" label="请款账号" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.account.startsWith('http')">
            <el-image style="width: 40px; height: 50px"
              :src="scope.row.account"
              :preview-src-list="[scope.row.account]">
            </el-image>
          </div>
          <div v-else>{{scope.row.account}}</div>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <!--
          <router-link class="fs-18 ml-10" :to="{path: '/adWatchwordEdit', query: {copy_awid: scope.row.awid}}">
            <i class="el-icon-copy-document"></i>
          </router-link>
          -->
          <router-link class="fs-18 ml-10" :to="{path: '/adWatchwordEdit', query: {awid: scope.row.awid}}">
            <i class="el-icon-edit"></i>
          </router-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import Clipboard from 'clipboard'
import {adWatchwordLists, adWatchwordEdit, adChnLists} from '../../../api/api'
import util from '../../../script/util'
import uploadHeadImage from '../../../components/uploadImage.vue'
import adSelect from '../../../components/data-select/adSelect.vue'
import operSelect from '../../../components/data-select/operSelect.vue'
export default {
  name: 'adWatchwordList',
  components: {
    uploadHeadImage,
    adSelect,
    operSelect
  },
  data () {
    return {
      opid: '',
      filters: {
        p: 1,
        l: 20,
        total: 0,
        adid: '',
        title: '',
        opid: '',
        acid: '',
        status: '',
        ieffect: '',
        show: '',
        address: ''
      },
      adLists: [],
      operLists: [],
      adChnLists: [],
      priorityLists: [],
      lists: [],
      listLoading: false,
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '停止',
          value: 0
        },
        {
          name: '运行',
          value: 1
        }
      ],
      showList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '内部',
          value: 0
        },
        {
          name: '全部',
          value: 1
        }
      ],
      ieffectList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '未收款',
          value: 0
        },
        {
          name: '已收款',
          value: 1
        }
      ]
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    setFiltersValue (key, value) {
      if (this.filters[key] === '') {
        this.filters[key] = value
      } else {
        this.filters[key] = ''
      }
      this.getList()
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (['total', 'order_amount', 'remain', 'price', 'income', 'all_income', 'chn_amount', 'unpaid'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    copyLink () {
      let clipboard = new Clipboard('.copy-btn')
      clipboard.on('success', e => {
        this.$notify({
          title: '成功',
          message: '复制成功',
          type: 'success'
        })

        // 释放内存
        clipboard.destroy()
      })

      clipboard.on('error', e => {
        this.$notify({
          title: '失败',
          message: '复制失败',
          type: 'error'
        })

        // 释放内存
        clipboard.destroy()
      })
    },
    getPriorityLists () {
      for (let index = 5; index >= 0; index--) {
        this.priorityLists.push({'label': index, 'value': index})
      }
    },
    adWatchwordEdit (index, key) {
      let awid = this.lists[index].awid
      let priority = this.lists[index].priority

      let params = {
        awid: awid
      }

      if (key === 'status') {
        params['status'] = this.lists[index].status === 1 ? 0 : 1
      }

      if (key === 'ieffect') {
        params['ieffect'] = this.lists[index].ieffect === 1 ? 0 : 1
      }

      if (key === 'show') {
        params['show'] = this.lists[index].show === 1 ? 0 : 1
      }

      if (key === 'priority') {
        params['priority'] = priority
      }

      adWatchwordEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getAdChnLists () {
      let params = {
        l: 500,
        p: 1,
        opid: this.opid
      }

      if ([2, 4, 16].includes(this.opid)) {
        delete params.opid
      }

      adChnLists(params).then((res) => {
        let data = res.data || {c: -1}

        if (!data.c) {
          this.adChnLists = data.d.lists.map((item, index) => {
            return {
              name: item.name,
              acid: item.acid
            }
          })
          this.adChnLists.unshift({
            name: '所有',
            acid: ''
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.adid !== '') {
        params.adid = filters.adid
      }
      if (filters.title !== '') {
        params.title = filters.title
      }
      if (filters.opid !== '') {
        params.opid = filters.opid
      }
      if (filters.acid !== '') {
        params.acid = filters.acid
      }
      if (filters.show !== '') {
        params.show = filters.show
      }
      if (filters.ieffect !== '') {
        params.ieffect = filters.ieffect
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      if (filters.address !== '') {
        params.address = filters.address
      }

      this.listLoading = true
      adWatchwordLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.opid = parseInt(window.localStorage.getItem('opid'))
    this.getPriorityLists()
    this.getAdChnLists()
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.adid': 'getList',
    'filters.title': 'getList',
    'filters.opid': 'getList',
    'filters.acid': 'getList',
    'filters.show': 'getList',
    'filters.ieffect': 'getList',
    'filters.status': 'getList',
    'filters.address': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/ad/adWatchwordList.vue